
import {IActionJavaData, IActionShellData, IActionData,createActionUtils} from '../../../action/'
import { ulid } from "ulid";
import {UI} from "./UI"
import { appNamespace } from "../app-namespace";
const type = `${appNamespace}toAppMainPage`
export interface IActionToAppMainPageJavaData extends IActionJavaData{
    pn:string
    an:string
}
export interface IActionToAppMainPage extends IActionData<IActionShellData, IActionToAppMainPageJavaData>{
    javaData:IActionToAppMainPageJavaData
}
function createDefaultData():IActionToAppMainPage{
    return {
        id:ulid(),
        type,
        javaData:{
            pn:'',
            an:''
        }
    }
}

function init(){

}

export const actionToAppMainPageUtils = createActionUtils(type, init, createDefaultData, UI )